import React from 'react';
export function ApiIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07 11A7.002 7.002 0 0112 5h4a1 1 0 011 1v2h6v2h-6v4h6v2h-6v2a1 1 0 01-1 1h-4a7.002 7.002 0 01-6.93-6H0v-2h5.07zM12 7h3v10h-3a5 5 0 010-10z"
  }));
}